export const DRAWER_TYPES = {
  portal: 1,
  login: 2,
  menu: 3,
};
